// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__2sKBq","title":"style_title__2MNHR","time":"style_time__3qXRj","content":"style_content__3_wu1"};